// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Screen Styles */
.home-screen {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: var(--space-3xl);
}

/* Header Section */
.home-header {
  padding: var(--space-lg) 0 var(--space-md) 0;
  background: transparent;
}

.home-header hr {
  border: none;
  height: 0.0625rem; /* 1px */
  background-color: rgba(204, 209, 209, 1);
  margin: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.header-left {
  flex: 1 1;
}

.greeting {
  font-size: 2.1875rem; /* 35px */
  font-weight: 600;
  line-height: 104%;
  letter-spacing: -4%;
  color: var(--color-primary);
  margin: 0 0 var(--space-sm) 0;
}

.date {
  font-weight: 100;
  font-size: 1rem; /* 16px */
  line-height: 114.99999999999999%;
  letter-spacing: -4%;
  color: rgba(60, 60, 60, 1);
  margin: 0;
}

.header-right {
  display: flex;
  gap: var(--space-sm);
  align-items: center;
}

.icon-button {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--radius-full);
  border: none;
  background: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--duration-fast) var(--easing-ease-out);
  box-shadow: var(--shadow-sm);
}

.icon-button:hover {
  transform: translateY(-0.125rem);
  box-shadow: var(--shadow-md);
}

.header-icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* Main Content */
.home-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
}

/* Energy Section */
.energy-section {
  margin-top: var(--space-md);
  display: flex;
  flex-direction: column;
}

/* Energy Usage and Money Spent Custom Components */
.energy-usage-content,
.money-spent-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.usage-title,
.money-title {
  font-weight: 400;
  font-size: 0.875rem; /* 14px */
  line-height: 120%;
  letter-spacing: -4%;
  color: var(--color-secondary-text);
  margin: 0;
}

/* Value containers */
.usage-value-container {
  display: flex;
  align-items: baseline;
  gap: var(--space-xs);
}

.money-value-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xs);
  width: 100%;
}

.money-value-container > div {
  display: flex;
  align-items: baseline;
  gap: var(--space-xs);
}

/* Values (38.2, 65.3) */
.usage-value,
.money-value {
  font-weight:500;
  font-size: 3.35rem !important; /* 52px */
  line-height: 100%;
  letter-spacing: -0.009375rem; /* -0.15px */
  color: var(--color-primary);
  margin: 0;
}

/* Units (kWh, €) */
.usage-unit,
.money-currency {
  font-weight: 100;
  font-size: 1rem !important; /* 16px - Mobile */
  line-height: 120%;
  letter-spacing: -0.009375rem; /* -0.15px */
  color: var(--color-secondary-text);
  margin: 0;
}

.energy-icon,
.money-icon {
  width: 1rem; /* 16px */
  height: 1rem; /* 16px */
}

/* Custom View Details Button */
.view-details-button {
  width: 8.75rem; /* 140px */
  height: 1.8125rem; /* 29px */
  padding: 0.375rem 1.875rem; /* 6px 30px */
  gap: 0.625rem; /* 10px */
  border-radius: 16.25rem; /* 260px */
  border: none;
  background-color: var(--color-button);
  color: var(--color-white);
  font-family: var(--font-family-regular);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--duration-fast) var(--easing-ease-out);
  opacity: 1;
  white-space: nowrap;
}

.view-details-button:hover {
  background: var(--color-success-dark);
  transform: translateY(-0.0625rem);
}



.view-details-btn {
  background: var(--color-success);
  color: var(--color-white);
  border: none;
  border-radius: var(--radius-lg);
  padding: var(--space-sm) var(--space-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--duration-fast) var(--easing-ease-out);
  white-space: nowrap;
}

.view-details-btn:hover {
  background: var(--color-success-dark);
  transform: translateY(-0.0625rem);
  box-shadow: var(--shadow-success);
}

/* Information Section */
.information-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

/* Info Card Components */
.info-card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 10rem; /* 160px */
  padding-top: var(--space-md);
  padding-left: var(--space-md);
  padding-bottom: var(--space-md);
}


.info-card-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.info-card-title {
  font-size: 1rem; /* 16px */
  line-height: 120%;
  letter-spacing: -4%;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0;
}

.info-card-description {
  font-size: 0.875rem; /* 14px */
  line-height: 140%;
  letter-spacing: -4%;
  color: var(--color-primary);
  margin: 0;
  margin-top: auto;
  padding-bottom: var(--space-xs);
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.info-card-icon {
  width: 1.25rem; /* 20px */
  height: 1.25rem; /* 20px */
  flex-shrink: 0;
}

/* Primary card (Smart Tips) specific styling */
.info-card-content--primary .info-card-title,
.info-card-title--primary {
  color: var(--color-white);
}

.info-card-content--primary .info-card-description,
.info-card-description--primary {
  color: var(--color-white);
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.section-title {
  font-size: 1.125rem; /* 18px */
  line-height: 120%;
  letter-spacing: -0.009375rem; /* -0.15px */
  font-weight: var(--font-weight-normal);
  color: var(--color-text-primary);
  margin: 0;
  text-align: left;
}

.info-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: var(--space-md);
}

.info-cards .custom-card:nth-child(3) {
  grid-column: 1 / -1; /* Smart Tips spans full width on mobile */
}


/* Desktop Responsive Design */
@media (min-width: 768px) {
  .home-screen {
    min-height: 100vh;
    padding-bottom: 0;
  }

  .home-header {
    padding: var(--space-xl) 0 var(--space-lg) 0;
  }

  .greeting {
    font-size: var(--font-size-5xl);
  }

  .date {
    font-size: var(--font-size-lg);
  }

  .icon-button {
    width: 3rem;
    height: 3rem;
  }

  .header-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .home-main {
    gap: var(--space-2xl);
  }

  .energy-section {
    flex-direction: row;
  }

  .energy-section .custom-card {
    flex: 1 1;
  }

  /* Desktop - Larger titles, values and units */
  .usage-title,
  .money-title {
    font-size: 1rem !important; /* 16px - Desktop (bigger than mobile 14px) */
  }

  .usage-value,
  .money-value {
    font-size: 4.3rem !important; /* 64px - Desktop (bigger than mobile 52px) */
  }

  .usage-unit,
  .money-currency {
    font-size: 1rem !important; /* 18px - Desktop */
  }

  .info-cards {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: var(--space-sm);
  }

  .info-cards .custom-card:nth-child(3) {
    grid-column: auto; /* Reset Smart Tips to normal width on desktop */
  }

  .info-card-content {
    height: 12rem; /* Bigger height on desktop */
  }

  .info-card-icon {
    width: 1.5rem; /* 24px - Desktop */
    height: 1.5rem; /* 24px - Desktop */
  }

  .info-card-title {
    font-size: 1.125rem; /* 18px - Desktop */
  }

  .info-card-description {
    font-size: 1rem; /* 16px - Desktop */
  }

  .section-title {
    font-size: 1.25rem; /* 20px - Desktop (bigger than mobile 18px) */
  }

  .home-screen {
    padding-bottom: 0; /* Remove padding on desktop since nav is fixed */
  }
}

@media (min-width: 1024px) {
  .greeting {
    font-size: clamp(2.5rem, 4vw, 3rem);
  }

  .energy-value,
  .money-value {
    font-size: clamp(2rem, 3vw, 2.5rem);
  }

  .info-cards {
    grid-template-columns: repeat(3, 1fr);
  }

}

@media (min-width: 1440px) {
  .home-screen {
    padding-bottom: 0;
  }
}

/* Mobile specific adjustments */
@media (max-width: 767px) {
  .view-details-btn {
    align-self: flex-end;
  }

  .info-cards {
    gap: var(--space-sm);
  }

  .info-card {
    padding: var(--space-md);
  }
}

/* Very small screens */
@media (max-width: 480px) {
  .greeting {
    font-size: var(--font-size-3xl);
  }

  .energy-value,
  .money-value {
    font-size: var(--font-size-3xl);
  }

  .info-card {
    padding: var(--space-sm);
  }

  .card-icon {
    width: 2.25rem;
    height: 2.25rem;
  }

  .card-icon-img {
    width: 1.125rem;
    height: 1.125rem;
  }
}


@media (max-width: 768px) {
  .info-card-content {
    padding-bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/HomeScreen.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB,EAAE,QAAQ;EAC3B,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe,EAAE,SAAS;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2DAA2D;EAC3D,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;;EAEE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;;EAEE,eAAe;EACf,6BAA6B,EAAE,SAAS;EACxC,iBAAiB;EACjB,4BAA4B,EAAE,YAAY;EAC1C,2BAA2B;EAC3B,SAAS;AACX;;AAEA,mBAAmB;AACnB;;EAEE,gBAAgB;EAChB,0BAA0B,EAAE,kBAAkB;EAC9C,iBAAiB;EACjB,4BAA4B,EAAE,YAAY;EAC1C,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,WAAW,EAAE,SAAS;EACtB,YAAY,EAAE,SAAS;AACzB;;AAEA,+BAA+B;AAC/B;EACE,cAAc,EAAE,UAAU;EAC1B,iBAAiB,EAAE,SAAS;EAC5B,0BAA0B,EAAE,aAAa;EACzC,aAAa,EAAE,SAAS;EACxB,uBAAuB,EAAE,UAAU;EACnC,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,uCAAuC;EACvC,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,2DAA2D;EAC3D,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;;;AAIA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa,EAAE,UAAU;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;AACjC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,SAAS;EACzB,eAAe,EAAE,SAAS;EAC1B,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB;EACjB,4BAA4B,EAAE,YAAY;EAC1C,sCAAsC;EACtC,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB,EAAE,0CAA0C;AACjE;;;AAGA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA,8CAA8C;EAC9C;;IAEE,0BAA0B,EAAE,6CAA6C;EAC3E;;EAEA;;IAEE,4BAA4B,EAAE,6CAA6C;EAC7E;;EAEA;;IAEE,0BAA0B,EAAE,mBAAmB;EACjD;;EAEA;IACE,qCAAqC;IACrC,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB,EAAE,gDAAgD;EACrE;;EAEA;IACE,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,aAAa,EAAE,mBAAmB;IAClC,cAAc,EAAE,mBAAmB;EACrC;;EAEA;IACE,mBAAmB,EAAE,mBAAmB;EAC1C;;EAEA;IACE,eAAe,EAAE,mBAAmB;EACtC;;EAEA;IACE,kBAAkB,EAAE,6CAA6C;EACnE;;EAEA;IACE,iBAAiB,EAAE,iDAAiD;EACtE;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,+BAA+B;EACjC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Home Screen Styles */\n.home-screen {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-top: var(--space-3xl);\n}\n\n/* Header Section */\n.home-header {\n  padding: var(--space-lg) 0 var(--space-md) 0;\n  background: transparent;\n}\n\n.home-header hr {\n  border: none;\n  height: 0.0625rem; /* 1px */\n  background-color: rgba(204, 209, 209, 1);\n  margin: 0;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.header-left {\n  flex: 1;\n}\n\n.greeting {\n  font-size: 2.1875rem; /* 35px */\n  font-weight: 600;\n  line-height: 104%;\n  letter-spacing: -4%;\n  color: var(--color-primary);\n  margin: 0 0 var(--space-sm) 0;\n}\n\n.date {\n  font-weight: 100;\n  font-size: 1rem; /* 16px */\n  line-height: 114.99999999999999%;\n  letter-spacing: -4%;\n  color: rgba(60, 60, 60, 1);\n  margin: 0;\n}\n\n.header-right {\n  display: flex;\n  gap: var(--space-sm);\n  align-items: center;\n}\n\n.icon-button {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: var(--radius-full);\n  border: none;\n  background: var(--color-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  box-shadow: var(--shadow-sm);\n}\n\n.icon-button:hover {\n  transform: translateY(-0.125rem);\n  box-shadow: var(--shadow-md);\n}\n\n.header-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Main Content */\n.home-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xl);\n}\n\n/* Energy Section */\n.energy-section {\n  margin-top: var(--space-md);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Energy Usage and Money Spent Custom Components */\n.energy-usage-content,\n.money-spent-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.usage-title,\n.money-title {\n  font-weight: 400;\n  font-size: 0.875rem; /* 14px */\n  line-height: 120%;\n  letter-spacing: -4%;\n  color: var(--color-secondary-text);\n  margin: 0;\n}\n\n/* Value containers */\n.usage-value-container {\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-xs);\n}\n\n.money-value-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-xs);\n  width: 100%;\n}\n\n.money-value-container > div {\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-xs);\n}\n\n/* Values (38.2, 65.3) */\n.usage-value,\n.money-value {\n  font-weight:500;\n  font-size: 3.35rem !important; /* 52px */\n  line-height: 100%;\n  letter-spacing: -0.009375rem; /* -0.15px */\n  color: var(--color-primary);\n  margin: 0;\n}\n\n/* Units (kWh, €) */\n.usage-unit,\n.money-currency {\n  font-weight: 100;\n  font-size: 1rem !important; /* 16px - Mobile */\n  line-height: 120%;\n  letter-spacing: -0.009375rem; /* -0.15px */\n  color: var(--color-secondary-text);\n  margin: 0;\n}\n\n.energy-icon,\n.money-icon {\n  width: 1rem; /* 16px */\n  height: 1rem; /* 16px */\n}\n\n/* Custom View Details Button */\n.view-details-button {\n  width: 8.75rem; /* 140px */\n  height: 1.8125rem; /* 29px */\n  padding: 0.375rem 1.875rem; /* 6px 30px */\n  gap: 0.625rem; /* 10px */\n  border-radius: 16.25rem; /* 260px */\n  border: none;\n  background-color: var(--color-button);\n  color: var(--color-white);\n  font-family: var(--font-family-regular);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  opacity: 1;\n  white-space: nowrap;\n}\n\n.view-details-button:hover {\n  background: var(--color-success-dark);\n  transform: translateY(-0.0625rem);\n}\n\n\n\n.view-details-btn {\n  background: var(--color-success);\n  color: var(--color-white);\n  border: none;\n  border-radius: var(--radius-lg);\n  padding: var(--space-sm) var(--space-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  white-space: nowrap;\n}\n\n.view-details-btn:hover {\n  background: var(--color-success-dark);\n  transform: translateY(-0.0625rem);\n  box-shadow: var(--shadow-success);\n}\n\n/* Information Section */\n.information-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n/* Info Card Components */\n.info-card-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 10rem; /* 160px */\n  padding-top: var(--space-md);\n  padding-left: var(--space-md);\n  padding-bottom: var(--space-md);\n}\n\n\n.info-card-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.info-card-title {\n  font-size: 1rem; /* 16px */\n  line-height: 120%;\n  letter-spacing: -4%;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.info-card-description {\n  font-size: 0.875rem; /* 14px */\n  line-height: 140%;\n  letter-spacing: -4%;\n  color: var(--color-primary);\n  margin: 0;\n  margin-top: auto;\n  padding-bottom: var(--space-xs);\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n.info-card-icon {\n  width: 1.25rem; /* 20px */\n  height: 1.25rem; /* 20px */\n  flex-shrink: 0;\n}\n\n/* Primary card (Smart Tips) specific styling */\n.info-card-content--primary .info-card-title,\n.info-card-title--primary {\n  color: var(--color-white);\n}\n\n.info-card-content--primary .info-card-description,\n.info-card-description--primary {\n  color: var(--color-white);\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n\n.section-title {\n  font-size: 1.125rem; /* 18px */\n  line-height: 120%;\n  letter-spacing: -0.009375rem; /* -0.15px */\n  font-weight: var(--font-weight-normal);\n  color: var(--color-text-primary);\n  margin: 0;\n  text-align: left;\n}\n\n.info-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto auto;\n  gap: var(--space-md);\n}\n\n.info-cards .custom-card:nth-child(3) {\n  grid-column: 1 / -1; /* Smart Tips spans full width on mobile */\n}\n\n\n/* Desktop Responsive Design */\n@media (min-width: 768px) {\n  .home-screen {\n    min-height: 100vh;\n    padding-bottom: 0;\n  }\n\n  .home-header {\n    padding: var(--space-xl) 0 var(--space-lg) 0;\n  }\n\n  .greeting {\n    font-size: var(--font-size-5xl);\n  }\n\n  .date {\n    font-size: var(--font-size-lg);\n  }\n\n  .icon-button {\n    width: 3rem;\n    height: 3rem;\n  }\n\n  .header-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n\n  .home-main {\n    gap: var(--space-2xl);\n  }\n\n  .energy-section {\n    flex-direction: row;\n  }\n\n  .energy-section .custom-card {\n    flex: 1;\n  }\n\n  /* Desktop - Larger titles, values and units */\n  .usage-title,\n  .money-title {\n    font-size: 1rem !important; /* 16px - Desktop (bigger than mobile 14px) */\n  }\n\n  .usage-value,\n  .money-value {\n    font-size: 4.3rem !important; /* 64px - Desktop (bigger than mobile 52px) */\n  }\n\n  .usage-unit,\n  .money-currency {\n    font-size: 1rem !important; /* 18px - Desktop */\n  }\n\n  .info-cards {\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: auto;\n    gap: var(--space-sm);\n  }\n\n  .info-cards .custom-card:nth-child(3) {\n    grid-column: auto; /* Reset Smart Tips to normal width on desktop */\n  }\n\n  .info-card-content {\n    height: 12rem; /* Bigger height on desktop */\n  }\n\n  .info-card-icon {\n    width: 1.5rem; /* 24px - Desktop */\n    height: 1.5rem; /* 24px - Desktop */\n  }\n\n  .info-card-title {\n    font-size: 1.125rem; /* 18px - Desktop */\n  }\n\n  .info-card-description {\n    font-size: 1rem; /* 16px - Desktop */\n  }\n\n  .section-title {\n    font-size: 1.25rem; /* 20px - Desktop (bigger than mobile 18px) */\n  }\n\n  .home-screen {\n    padding-bottom: 0; /* Remove padding on desktop since nav is fixed */\n  }\n}\n\n@media (min-width: 1024px) {\n  .greeting {\n    font-size: clamp(2.5rem, 4vw, 3rem);\n  }\n\n  .energy-value,\n  .money-value {\n    font-size: clamp(2rem, 3vw, 2.5rem);\n  }\n\n  .info-cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n}\n\n@media (min-width: 1440px) {\n  .home-screen {\n    padding-bottom: 0;\n  }\n}\n\n/* Mobile specific adjustments */\n@media (max-width: 767px) {\n  .view-details-btn {\n    align-self: flex-end;\n  }\n\n  .info-cards {\n    gap: var(--space-sm);\n  }\n\n  .info-card {\n    padding: var(--space-md);\n  }\n}\n\n/* Very small screens */\n@media (max-width: 480px) {\n  .greeting {\n    font-size: var(--font-size-3xl);\n  }\n\n  .energy-value,\n  .money-value {\n    font-size: var(--font-size-3xl);\n  }\n\n  .info-card {\n    padding: var(--space-sm);\n  }\n\n  .card-icon {\n    width: 2.25rem;\n    height: 2.25rem;\n  }\n\n  .card-icon-img {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .info-card-content {\n    padding-bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
